import { render } from "./FormInputText.vue?vue&type=template&id=10bdd99e&scoped=true&lang=pug&bindings={\"label\":\"props\",\"type\":\"props\",\"name\":\"props\",\"required\":\"props\",\"id\":\"props\",\"value\":\"setup\",\"valueValidate\":\"setup\",\"validate\":\"setup\",\"className\":\"setup\"}"
import script from "./FormInputText.vue?vue&type=script&lang=js"
export * from "./FormInputText.vue?vue&type=script&lang=js"

import "./FormInputText.vue?vue&type=style&index=0&id=10bdd99e&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-10bdd99e"

export default script